import { Stack, StackProps, styled } from "@mui/material";
import { FC, ReactNode } from "react";

type TFooterContainerProps = {
  children: ReactNode;
  padding?: string | number;
} & StackProps;

export const FooterContainer: FC<TFooterContainerProps> = ({ children, padding = "24px", ...props }) => {
  return (
    <StyledFooterContainer padding={padding} {...props}>
      {children}
    </StyledFooterContainer>
  );
};

const StyledFooterContainer = styled(Stack)<{ padding: string | number }>`
  position: sticky;
  bottom: 32px;
  left: 0;
  padding: ${({ padding }) => (typeof padding === "number" ? `${padding}px` : padding)};
  border-top: 1px solid #e6e7e8;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 #00000026;
  z-index: 1000;
  height: 85px;
`;
